(function () {
    angular.module('tmx-app').controller('customersCtrl', ['$state', '$filter','CustomersService','ToastService',
        '$mdSidenav', 'TmxDialogService', 'tmxUtility', 'menu', 
    
        function CustomersCtrl($state,$filter, CustomersService,ToastService, $mdSidenav, TmxDialogService, tmxUtility, menu) {
            var customerVM = this;
            var exists;
            var copy;
            customerVM.EntityName = "Customers";
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;


    ///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            customerVM.menu = menu;
            customerVM.Privileges = [];
            customerVM.ViewPrivilege = false;
            customerVM.EditPrivilege = false;
            customerVM.DeletePrivilege = false;
            customerVM.AddPrivilege = false;
            customerVM.checkPermission = tmxUtility.checkPermission;

            customerVM.viewPermission = customerVM.checkPermission("Private.Masterdata.Customers","View") ;
            customerVM.editPermission = customerVM.checkPermission("Private.Masterdata.Customers","Edit") ;         

    ///////////////////FUNCTIONS////////////////////////
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            customerVM.checkAddDisabled = function () {
                if ($mdSidenav(customerVM.nav).isOpen()) {
                    return true;
                }
                else {
                    return false;
                }
            };
            customerVM.formatCNIC = function (NationalIdentifierValue) {
                if (!NationalIdentifierValue) return 'N/A';
                return NationalIdentifierValue;
            };
            customerVM.formatPhoneNumber = function (contactNumber) {
      // if(exists(dataitem,"TmxCustomerHousehold[0].MobileNumber1"))
                if (angular.isDefined(contactNumber) && contactNumber != null) {
                    return "+" + contactNumber;
                }
                return "";
            }
            customerVM.isFiltered = function (fieldName) {
                var filtered = false;
                if (fieldName == "Status") {
                    fieldName = "EffectiveEndDate";
                }

                if (angular.isDefined(customerVM.filters)) {
                    customerVM.filters.filters.forEach(function (filter) {
                        if (filter.field == fieldName) { filtered = true; }
                        else if (filter.field == "EffectiveStartDate" && fieldName == "EffectiveEndDate") {
                            filtered = true;
                        }
                    });
                }
                return filtered;
            }

            customerVM.IsRecommended = function(recommendationAmount){
              
                return (tmxUtility.exists(recommendationAmount) && recommendationAmount > 0)  ? 'Recommended': 'Not Recommended';
            }

            customerVM.formatAmount = function(amount, defaultValue){
                if(!tmxUtility.exists(amount) || amount <= 0){
                    if(tmxUtility.exists(defaultValue)){
                        return defaultValue;
                    }
                    else {
                        return 'N/A';
                    }
                }
                return tmxUtility.formatAmount(amount);
            }

            customerVM.getBranchName = function (dataitem) {
                if (angular.isDefined(dataitem.BranchName))
                    return dataitem.BranchName;
                return "N/A";
            };        

            customerVM.isEditable = function (dataitem) {
                if (dataitem.Status == "Active" || dataitem.Status == "Pending") {
                    return true;
                }
                return false;
            }
            customerVM.reload = function () {
                customerVM.container.userGrid.dataSource.read();
            };
            customerVM.success = function (promise) {
                if (promise.read == true) {
                    customerVM.container.userGrid.dataSource.transport.read(promise);
                }
                else {
                    customerVM.container.userGrid.dataSource.read();
                }
                customerVM.toggleSearch(customerVM.nav);
            };
            customerVM.onChildState = function () {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            };
            customerVM.new = function () {
      //.path(.url()+'/new');
      //customerVM.searchClear = true;
                $state.data.info = false;
                $state.go($state.current.name + ".add");
            };
            customerVM.clickEdit = function (item) {
      //customerVM.searchClear = true;
                $state.data.info = false;
                $state.go($state.current.name + ".edit", {
                    "Id": item.CustomerMasterId
                });
            };
            customerVM.clickView = function (item) {
      //customerVM.searchClear = true;
                $state.data.info = true;
                $state.go($state.current.name + ".edit", { "Id": item.CustomerMasterId });
            }
            customerVM.formatCustomerName = function (CustomerName) {

                return tmxUtility.sliceText(CustomerName, 25);
            };


            customerVM.clickDeactivate = function (item) {
      //var confirm = $mdDialog.confirm()
      //.title('Deactivate Customer '+item.CustomerName+" ?")
      //.textContent('Are you sure you want to deactivate this Customer?')
      //.ariaLabel('Deactivate Customer')
      //.clickOutsideToClose(true)
      //.ok('Yes')
      //.cancel('Cancel');
      //$mdDialog.show(confirm).then(
      //  function() {
      //  customerVM.Deactivate(item);
      //  }, function() {
      //  }
      //);
                var diagConfig = {
                    action: "Deactivate",
                    entity: "Customer",
                    entityname: item.CustomerName,
                    details: [
                        { value: item.CustomerName, label: "Customer Name" },
                        { value: item.NationalIdentifierValue, label: "CNIC" },
                        { value: item.ContactNumber, label: "Contact Number" },
                        { value: item.Status, label: "Status" }
                    ],
                    options: [
                        { label: "Deactivate", value: true, class: "md-warn" },
                        { label: "Cancel", value: false, class: "md-primary" }
                    ]
                };
                function callback(ok) {
                    if (ok) {
                        customerVM.Deactivate(item);
                    }
                }
                var customerDeactivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);
                customerDeactivateDialog.show();

            };
            customerVM.clickActivate = function (item) {

                var diagConfig = {
                    action: "Activate",
                    entity: "Customer",
                    entityname: item.CustomerName,
                    details: [
                        { value: item.CustomerName, label: "Customer Name" },
                        { value: item.NationalIdentifierValue, label: "CNIC" },
                        { value: item.ContactNumber, label: "Contact Number" },
                        { value: item.Status, label: "Status" }
                    ],
                    options: [
                        { label: "Activate", value: true, class: "md-warn" },
                        { label: "Cancel", value: false, class: "md-primary" }
                    ]
                };
                function callback(ok) {
                    if (ok) {
                        customerVM.Activate(item);
                    }
                }
                var customerActivateDialog = new TmxDialogService.confirmDialog(diagConfig, callback);
                customerActivateDialog.show();
            };

            customerVM.Deactivate = function (item) {
                item.$deactivate(item.CustomerMasterId).then(function () {
                    customerVM.container.userGrid.dataSource.read();
                });
            };
            customerVM.Activate = function (item) {
                item.$activate(item.CustomerMasterId).then(function () {
                    customerVM.container.userGrid.dataSource.read();
                });
            };
            customerVM.isStatusActive = function (Status) {
                if (Status == "Active") return true;
                return false;
            };

            customerVM.isStatusPending = function (status) {
                if (status == "Pending") return true;
                return false;
            };
            customerVM.onClick = function (e, dataItem) {
                var element = $(e.currentTarget);
                var checked = element.is(':checked');
                var row = element.closest("tr");
                if (checked) {
                    row.addClass("k-state-selected");
                    customerVM.addToBulk(dataItem);
                }
                else {
                    row.removeClass("k-state-selected");
                    customerVM.removeFromBulk(dataItem);
                }
            };

            customerVM.toggleSearch = function () {
                if (customerVM.searchSideNavActive) {
        // customerVM.searchData = {};
                    customerVM.searchSideNavActive = false;
                }
                else
                    customerVM.searchSideNavActive = true;
                customerVM.toggle('SearchSideNav');
            }
            customerVM.toggleExport = function () {
                if (customerVM.exportSideNavActive)
                    customerVM.exportSideNavActive = false;
                else
                    customerVM.exportSideNavActive = true;
                customerVM.toggle('ExportSideNav');
            }
            customerVM.isOpen = function (navID) {
                return $mdSidenav(navID).isOpen();
            };
            customerVM.toggle = function (navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () { });
            };
            customerVM.SendSms = function(){
                // Only for Demo
                ToastService.showCustomToast("success", $filter('translate')("SMSJobInitiated"));
                setTimeout(function(){
                    ToastService.showCustomToast("success", $filter('translate')("SMSJobCompleted"));
                },5000);
                                
            }
            customerVM.search = function (navID) {
                let calls = [];
                for (var key in customerVM.searchData) {
                    if (customerVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: customerVM.searchData[key]
                        });
                    }
                }
                customerVM.filt = {
                    filters: calls,
                    logic: "and"
                };
      // customerVM.searchObject.data.filter=customerVM.filt;
                customerVM.o.data.filter = customerVM.filt;
 
                customerVM.container.userGrid.dataSource.transport.read(customerVM.o);
      // customerVM.searchData = {};
                customerVM.toggle(navID);
            };
            customerVM.clear = function (navID) {
      // customerVM.searchData = {};
                customerVM.toggle(navID);
            };
            customerVM.clearSideNav = function () {
                customerVM.searchData = {};
            };                 
    ////////////////////////////////////////////////////


    //////////////////////CODE//////////////////////////
            customerVM.query = "CustomerMaster"
            customerVM.CustomersService = CustomersService;
            customerVM.cols = CustomersService.gridColumn;
            customerVM.nav = "SearchSideNav";
            customerVM.schema = CustomersService.schema;
    // customerVM.Devices = resolvedData.Devices.data;
    // customerVM.date = new Date().toJSON();
            customerVM.date = new Date().toJSON();
            var arr = customerVM.date.split("T");
            var arr2 = arr[1].split(":");
            arr2[0] = (Number(arr2[0]) + 5).toString();
            customerVM.date = arr[0] + "T" + arr2[0] + ":" + arr2[1] + ":" + arr2[2];
            customerVM.gridData = new kendo.data.ObservableArray([]);
            customerVM.cloneColumn = angular.copy(CustomersService.gridColumn);
            customerVM.clone = 0;
            customerVM.dataObj = {
                value: "empty"
            };
            customerVM.gridColumns = angular.copy(CustomersService.columns);         
            customerVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            if (angular.isDefined(customerVM.searchClear) && customerVM.searchClear == false) {
                                if (exists(customerVM.o)) {
                                    copy(customerVM.o.data, ["filter"], o.data);
                                }
                            }
                            customerVM.searchClear = false;
                            if (customerVM.onChildState()) { return; }
                            if (!o.fromSideNav) {
                                if ($state.searchClear) {
                                    customerVM.searchClear = true;
                                    $state.searchClear = undefined;
                //return;
                                }
              //if(exists(customerVM.o))
              //  copy(customerVM.o.data,["filter"],o.data);
                            }
                            else {
                                o.data.firstPage = true;
                            }

                            customerVM.o = angular.copy(o);
                            customerVM.filters = customerVM.o.data.filter;
                            CustomersService.getByParams(o, true).then(function (response) {
                                parseResppnse(response.data);
                                customerVM.excelData=response;
                                o.success(response)
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort: [{ field: "CustomerMasterId", dir: "desc" }/*,{field: "CreatedDate", dir: "desc"}*/],
                },
      // selectable: "multiple, row",
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                excelExport: function(e) {                                         
                    var sheet = e.workbook.sheets[0];
                    var data = customerVM.excelData.data;
                    var gridColumns = customerVM.container.userGrid.columns;                    
                    var columns = tmxUtility.columnsMapping(gridColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);                    
                    sheet.rows = rows;
                },
                pdf: {
                    allPages: true,
                    fileName: "Customers.pdf"
                },
                excel: {
        /* allPages: true,*/
                    fileName: "Customers.xlsx"
                },
                sortable: true,
                scrollable: false,
      //rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': CustomersCtrl.isStatusActive(dataItem)}\"><td><input type='checkbox' class='checkbox' ng-click='CustomersCtrl.onClick($event,dataItem)' /> </td><td>#= CompanyCode # </td><td>#= CompanyName # </td><td>#= CompanyTypeLkp # </td><td><md-button ng-disabled='CustomersCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='CustomersCtrl.clickDelete(dataItem)'> <md-icon md-svg-src='assets/images/garbage12.svg' /></md-button><md-button ng-disabled='CustomersCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='CustomersCtrl.clickEdit(dataItem)'> <md-icon md-svg-src='assets/images/edit45.svg' /></md-button><tmx-duplicate disable='CustomersCtrl.isStatusActive(dataItem)' model='dataItem' schema='CustomersCtrl.schema' columns='CustomersCtrl.cloneColumn' on-submit='CustomersCtrl.reload()'> </tmx-duplicate></td></tr>",
                columns: customerVM.gridColumns
            };
            customerVM.bulk = [];
            customerVM.container = {};
            $state.data = {
                grid: customerVM.container
            };
            customerVM.searchSideNavActive = false;
            customerVM.exportSideNavActive = false;
            customerVM.filt = {};

            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);    
                    dataItem.ContactNumber=customerVM.formatPhoneNumber(dataItem.ContactNumber);
                    dataItem.NationalIdentifierValue=customerVM.formatCNIC(dataItem.NationalIdentifierValue);
                    dataItem.CustomerName=customerVM.formatCustomerName(dataItem.CustomerName);
                    dataItem.statusActive=customerVM.isStatusActive(dataItem.Status);
                    dataItem.statusPending=customerVM.isStatusPending(dataItem.Status);
                });
            }
    ////////////////////////////////////////////////////
        }]);
})();
